// NPM Imports
import { QUOTES } from "../constants";

/*
===================
 QuoteList Functions
===================
*/

export const prepareQuoteStatusCount = quoteList => {
  let quoteStatusCount = QUOTES.QUOTE_STATUS_MAP.map(status => {
    status.count = 0;
    return status;
  });
  quoteList.forEach(quote => {
    quoteStatusCount = quoteStatusCount.map(status => {
      if (quote.status === status.value) {
        status.count += 1;
        return status;
      }
      return status;
    });
  });
  return quoteStatusCount;
};

export const matchQuoteStatusLabelWithValue = value => {
  const currentStatus = QUOTES.QUOTE_STATUS_MAP.find(
    status => status.value === value,
  );
  return currentStatus.label;
};

/*
===================
 Catalog Functions
===================
*/

// For checkbox default state in ProductListItems component
export const formatProductItems = (items, addedCatalogIds) =>
  items.PriceListItems.forEach(item => {
    item.isChecked = false;
    item.isDisabled = addedCatalogIds.includes(item.id);
  });

/*
=====================
  Quote Terms Functions
=====================
*/

export const transformQuotetermTemplateFormFields = terms => {
  // eslint-disable-next-line camelcase
  const { field_values, template_data, quote_id } = terms;
  const template = {
    id: template_data.id,
    name: template_data.name,
    template: template_data.template,
    quoteID: quote_id,
  };
  const formFields = template_data.fieldForms.map(field => {
    const valueField = { ...field };
    valueField.value = field_values[field.id];
    return valueField;
  });
  template.fieldForms = formFields;
  return template;
};



// WEBPACK FOOTER //
// ./src/utils/quotesUtils.js